import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import {
  containerWrapperCss,
  previewContainerCss,
  previewHeaderTextStyles,
  templateContainerCss,
  templateFormCss,
} from "./ExportablesTemplatePreview.style";
interface ExportablesPreviewProps {
  isStudent: boolean;
}

const ExportablesTemplatePreview = ({ isStudent }: ExportablesPreviewProps) => {
  const { formData, setFormData, selectedExportable, templateList } =
    useExportablesContext();

  if (!selectedExportable) return null;

  const SelectedComponent = selectedExportable.Component;
  const templateListLength = templateList?.length || 0;
  const currentTemplateIndex =
    templateList?.findIndex(
      ({ seti_identifier }) =>
        seti_identifier === selectedExportable.seti_identifier,
    ) || 0;
  const header =
    isStudent &&
    templateListLength > 1 &&
    `Graphic organizers ${currentTemplateIndex + 1} of ${templateListLength}`;

  const currentFormData = formData[selectedExportable.seti_identifier] || {};

  const handleSelectedFormDataChange = (updatedData: Record<string, any>) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [selectedExportable.seti_identifier]: {
        ...(prevFormData[selectedExportable.seti_identifier] || {}),
        ...updatedData,
      },
    }));
  };

  return (
    <div css={containerWrapperCss}>
      {header && <h2 css={previewHeaderTextStyles}>{header}</h2>}
      <div css={previewContainerCss}>
        <div css={templateContainerCss}>
          <form css={templateFormCss} aria-label="Template Preview">
            <SelectedComponent
              formData={currentFormData}
              onChange={handleSelectedFormDataChange}
              title={selectedExportable.title}
              isStudent={isStudent}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ExportablesTemplatePreview;
